import { Button } from '@/shared/components/ui/button'
import { X } from 'lucide-react'
import React from 'react'

const StoryboardImageLightbox = ({
    imageUrl,
    onClose
}: {
    imageUrl: string;
    onClose: () => void;
}) => (
    <div
        className="fixed inset-0 z-50 flex items-center justify-center bg-background/90 backdrop-blur-sm p-4 animate-in fade-in duration-200"
        onClick={onClose}
    >
        <div className="relative max-w-5xl max-h-[90vh] w-full h-full flex items-center justify-center">
            <img
                src={imageUrl}
                alt="Expanded View"
                className="max-w-full max-h-full object-contain rounded-lg shadow-2xl"
            />
            <Button
                variant="ghost"
                size="icon"
                className="absolute top-4 right-4 text-white bg-black/50 hover:bg-black/70 rounded-full h-10 w-10"
                onClick={(e) => {
                    e.stopPropagation()
                    onClose()
                }}
            >
                <span className="sr-only">Close</span>
                <X className="h-6 w-6" />
            </Button>
        </div>
    </div>
)

export default StoryboardImageLightbox
